import {SPIIDEO_STADIUM_MAPPING} from '@constants/resources';
import {SECURITY_PRIVILEGES_READ} from '@constants/variables';


export const authorizationObject = {
    [SPIIDEO_STADIUM_MAPPING]: SECURITY_PRIVILEGES_READ,
};
